export default {
  install(Vue) {
    Vue.prototype.inputFixed = function (value) {
      value = value.replace(/[^\d.]/g, '') // 清除"数字"和"."以外的字符
      value = value.replace(/^[0]\d/g, '')
      value = value.replace(/^\./g, '') // 验证第一个字符是数字
      value = value.replace(/\.{2,}/g, '.') // 只保留第一个, 清除多余的
      value = value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
      value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') // 控制可输入的小数
      return value
    }
    // 表格居中
    Vue.prototype.tableCenter = function () {
      return 'text-align: center;'
    }
    // 表头
    Vue.prototype.tableHeaderCenter = function () {
      return `
                text-align: center;
                font-size: 14px;
                font-weight:500;
                color: #333;
                background: #fafcff;
            `
    }
    // 过滤空值，返回新对象
    Vue.prototype.filterEmpyKey = function (data) {
      const obj = {}
      Object.keys(data).forEach(item => {
        if (data[item] !== null && data[item] !== '' && typeof (data[item]) !== 'undefined' && !obj[item]) {
          obj[item] = data[item]
        }
      })
      return obj
    }

    Vue.prototype.arrayToTree = function (data, parentId) {
      let temp, tree = [];
      data.forEach(item => {
        if (item.parentId == parentId) {
          temp = this.arrayToTree(data, item.id);
          if (temp.length > 0) {
            item.children = temp
          }
          tree.push(item);
        }
      })
      return tree;
    }

    Vue.prototype.arrayToTreeDisabled = function (data, parentId) {
      let temp, tree = [];
      data.forEach(item => {
        if (item.parentId == parentId) {
          temp = this.arrayToTreeDisabled(data, item.id);
          if (temp.length > 0) {
            item.children = temp
          } else if (temp.length == 0 && (item.level == 1 || item.level == 2 || item.level == 3)) {
            item.disabled = true
          }
          tree.push(item);
        }
      })
      return tree;
    }

    /**
     * tree裁剪
     * @param data 元数据
     * @param fArray 过滤数组 <权限/可用>
     * @param level 过滤等级
     * @returns {Array}
     */
    Vue.prototype.formatTree = function (data, fArray, level) {
      let filterData = []
      if (level > 0 || fArray.length > 0) {
        if (level > 0) filterData = data.filter(item => item.level == level)
        if (fArray.length > 0) filterData = filterData.concat(fArray)
        for (let i = 0; i < filterData.length; i++) {
            if (filterData[i].parentId != null) {
              let targetObj = data.find(v => v.id == filterData[i].parentId)
              targetObj&&!filterData.includes(targetObj) && filterData.push(targetObj)
            }
        }
      } else {
        filterData = data
      }
      return this.arrayToTree(filterData)
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/globalMethods.js